__turbopack_context__.v({
  "actualPrice": "PriceContainer-module-scss-module__KrYs-G__actualPrice",
  "actualPriceInCartDiscount": "PriceContainer-module-scss-module__KrYs-G__actualPriceInCartDiscount",
  "actualPriceMemberGroup": "PriceContainer-module-scss-module__KrYs-G__actualPriceMemberGroup",
  "discountLabel": "PriceContainer-module-scss-module__KrYs-G__discountLabel",
  "discountRow": "PriceContainer-module-scss-module__KrYs-G__discountRow",
  "memberDiscountLabel": "PriceContainer-module-scss-module__KrYs-G__memberDiscountLabel",
  "originalPrice": "PriceContainer-module-scss-module__KrYs-G__originalPrice",
  "priceContainer": "PriceContainer-module-scss-module__KrYs-G__priceContainer",
  "srOnly": "PriceContainer-module-scss-module__KrYs-G__srOnly",
});
